// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { setLocalStorageItem } from "../../../../src/utils/index";
// import { Button, Input, message } from "antd";
// import { images } from "../../../assets/images";
// import { loginApi } from "../../../ApiServices/Apifun"; 

// function Login() {
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(false);
//   const [userData, setUserData] = useState({ email: "", password: "" });

//   const handlelogin = () => {
//     setLoading(true);
//     const data = {
//       loginId: userData.email,
//       password: userData.password,
//     };
//     loginApi(data)
//       .then((response) => {

//         if (response.status) {
//           setLocalStorageItem("token_vendor", response.data?.access_token);
//           setLocalStorageItem("user", response.data?.user);
//           setLocalStorageItem("wallet", response.data?.walletBalance);
//           setLocalStorageItem("login", true);
//           navigate("/dashboard");
//           message.success("Vendor Logged In Successfully");
//         }
//       })
//       .catch((error) => {
//         console.log(error);
//       })
//       .finally(() => setLoading(false));
//   };

//   const handleKeyPress = (e) => {
//     if (e.key === "Enter") {
//       handlelogin();
//     }
//   };
//   return (
//     <div className="h-screen px-4 bg-[#fff3f3] flex items-center">
//       <div className="w-[1200px]  max-w-[100%] mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2  shadow-[-5px_0px_15px_#ddd]">
//         <div>
//           <div className="h-[100%]">
//             <img
//               src={images.login}
//               alt="logo"
//               className="flex justify-center rounded-s-md items-center object-cover h-[100%]"
//             />
//           </div>

//           {/* <p className=" text-center text-sm  text-white  font-medium">
//             With the websites of Ezulix, you can now focus only on functionaries
//             for your digital products, while leaving the UI design on us
//           </p> */}
//         </div>
//         <div className="p-12 rounded-e-md bg-white">
//           <p className="  text-2xl   block text-rgbaprimary9  font-medium mb-6">
//             Sign In
//           </p>
//           <div className=" my-4">
//             <label
//               className="block text-rgbaprimary9 text-md font-medium mb-4"
//               htmlFor="username"
//             >
//               Email Address
//             </label>
//             <Input
//               type="email"
//               // placeholder="Enter mobile number here..."
//               name="email"
//               onKeyDown={handleKeyPress}
//               required
//               className="shadow appearance-none border rounded w-full py-3 px-3 text-rgbaprimary9 text-sm leading-tight focus:outline-none focus:shadow-outline"
//               onChange={(e) =>
//                 setUserData({ ...userData, email: e.target.value })
//               }
//             />
//           </div>
//           <div className="">
//             <label
//               className="block text-rgbaprimary9 text-md font-medium mb-4"
//               htmlFor="password"
//             >
//               Password
//             </label>
//             <Input.Password
//               // placeholder="Enter password here..."
//               name="password"
//               onKeyDown={handleKeyPress}
//               required
//               className="shadow appearance-none border rounded w-full py-2 px-3 text-rgbaprimary9 text-sm leading-tight focus:outline-none focus:shadow-outline mb-7"
//               onChange={(e) =>
//                 setUserData({ ...userData, password: e.target.value })
//               }
//             />
//           </div>

//           <Button
//             loading={loading}
//             type="button"
//             className="text-white h-10 bg-rgbaprimary8 w-full font-semibold"
//             onClick={handlelogin}
//           >
//             Login
//           </Button>
//           <p onClick={()=>navigate("/register")} className="text-center flex justify-end mt-5  underline cursor-pointer text-rgbaprimary8">Register Now ?</p>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Login;


import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { setLocalStorageItem } from "../../../../src/utils/index";
import { Button, Input, message, Modal } from "antd";
import { images } from "../../../assets/images";
import { forgotPassword, loginApi, resetPassword, verifyForgotOtp } from "../../../ApiServices/Apifun";

// ---- Brand tokens (DineValts) ----
const GOLD = "#C9A227";
const CHARCOAL = "#17140F";

// ---- Small inline icons (no extra dependency needed) ----
const IconMail = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" {...props}>
    <rect x="3.5" y="5.5" width="17" height="13" rx="2" />
    <path d="M4.5 7l7.5 6 7.5-6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
const IconLock = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" {...props}>
    <rect x="4.5" y="10.5" width="15" height="9.5" rx="2" />
    <path d="M7.5 10.5V7.5a4.5 4.5 0 0 1 9 0v3" strokeLinecap="round" />
  </svg>
);


const fieldWrapperClass =
  "border rounded-lg border-[#E6DFC9] bg-[#FCFAF4] focus-within:border-[#C9A227] focus-within:shadow-[0_0_0_3px_rgba(201,162,39,0.15)] transition-shadow";

function Login() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState({ email: "", password: "" });
  const [forgotOpen, setForgotOpen] = useState(false);
  const [step, setStep] = useState(1);

  const [forgotData, setForgotData] = useState({
    email: "",
    otp: "",
    password: "",
    confirmPassword: "",
    resetToken: ""
  });

  const [forgotLoading, setForgotLoading] = useState(false);

  const handleSendOtp = () => {

    if (!forgotData.email) {
      message.error("Please enter email.");
      return;
    }

    setForgotLoading(true);

    forgotPassword({
      email: forgotData.email,
    })
      .then((res) => {

        if (res.status === "success" || res.status === true) {

          message.success(res.message);

          setStep(2);

        } else {

          message.error(res.message);

        }

      })
      .catch((err) => {

        message.error(err.message);

      })
      .finally(() => {

        setForgotLoading(false);

      });

  };
  const handleVerifyOtp = () => {

    if (!forgotData.otp) {
      message.error("Please enter OTP.");
      return;
    }

    setForgotLoading(true);

    verifyForgotOtp({
      email: forgotData.email,
      otp: forgotData.otp,
    })
      .then((res) => {

        if (res.status === "success" || res.status === true) {

          message.success(res.message);

          setForgotData((prev) => ({
            ...prev,
            resetToken: res.data.resetToken,
          }));

          setStep(3);

        } else {

          message.error(res.message);

        }

      })
      .catch((err) => {

        message.error(err.message);

      })
      .finally(() => {

        setForgotLoading(false);

      });

  };

  const handleResetPassword = () => {

    if (!forgotData.password || !forgotData.confirmPassword) {

      message.error("Please enter password.");

      return;
    }

    if (forgotData.password !== forgotData.confirmPassword) {

      message.error("Passwords do not match.");

      return;
    }

    setForgotLoading(true);

    resetPassword({

      email: forgotData.email,

      resetToken: forgotData.resetToken,

      password: forgotData.password,

      confirmPassword: forgotData.confirmPassword,

    })
      .then((res) => {

        if (res.status === "success" || res.status === true) {

          message.success(res.message);

          setForgotOpen(false);

          setStep(1);

          setForgotData({
            email: "",
            otp: "",
            password: "",
            confirmPassword: "",
            resetToken: "",
          });

        } else {

          message.error(res.message);

        }

      })
      .catch((err) => {

        message.error(err.message);

      })
      .finally(() => {

        setForgotLoading(false);

      });

  };

  const handlelogin = () => {
    setLoading(true);
    const data = {
      loginId: userData.email,
      password: userData.password,
    };
    loginApi(data)
      .then((response) => {
        console.log("response", response);
        if (response.status) {
          setLocalStorageItem("token_vendor", response.data?.access_token);
          setLocalStorageItem("user", response.data?.user);
          setLocalStorageItem("wallet", response.data?.walletBalance);
          setLocalStorageItem("login", true);
          navigate("/dashboard");
          message.success("Vendor Logged In Successfully");
        } else {
          console.log("cheking dfdfdfd");
          alert("ffdgdg");
          message.error(response.message || "Invalid email or password");
        }
      })
      .catch((error) => {
        message.error(
          error?.response?.data?.message ||
          error?.message ||
          "Login failed"
        );

        console.log(error);
      })
      .finally(() => setLoading(false));
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handlelogin();
    }
  };

  return (
    <>
      <Modal
        open={forgotOpen}
        footer={null}
        centered
        destroyOnClose
        onCancel={() => {
          setForgotOpen(false);
          setStep(1);
        }}
        title="Forgot Password"
      >

        {step === 1 && (

          <>
            <Input
              placeholder="Enter Email"
              value={forgotData.email}
              onChange={(e) =>
                setForgotData({
                  ...forgotData,
                  email: e.target.value,
                })
              }
            />

            <Button
              type="button"
              loading={forgotLoading}
              className="!h-11 mt-3 !rounded-lg !text-sm !font-semibold !text-[#17140F] !border-0 w-full"
              style={{ backgroundColor: GOLD }}
              onClick={handleSendOtp}
            >
              Send OTP
            </Button>

          </>

        )}

        {step === 2 && (

          <>
            <Input
              placeholder="Enter OTP"
              value={forgotData.otp}
              onChange={(e) =>
                setForgotData({
                  ...forgotData,
                  otp: e.target.value,
                })
              }
            />

            <Button
              loading={forgotLoading}
              type="button"
              className="!h-11 mt-3 !rounded-lg !text-sm !font-semibold !text-[#17140F] !border-0 w-full"
              style={{ backgroundColor: GOLD }}
              onClick={handleVerifyOtp}
            >
              Verify OTP
            </Button>

          </>

        )}

        {step === 3 && (

          <>
            <Input.Password
              placeholder="New Password"
              value={forgotData.password}
              onChange={(e) =>
                setForgotData({
                  ...forgotData,
                  password: e.target.value,
                })
              }
            />

            <Input.Password
              className="mt-3"
              placeholder="Confirm Password"
              value={forgotData.confirmPassword}
              onChange={(e) =>
                setForgotData({
                  ...forgotData,
                  confirmPassword: e.target.value,
                })
              }
            />

            <Button
              loading={forgotLoading}
              type="primary"
              className="w-full mt-4"
              onClick={handleResetPassword}
            >
              Reset Password
            </Button>

          </>

        )}

      </Modal>
      <div className="min-h-screen w-full flex items-center justify-center bg-[#FCFAF4] px-4 py-10">
        <div className="w-[1200px] max-w-full mx-auto grid grid-cols-1 md:grid-cols-2 rounded-2xl overflow-hidden border border-[#EDE6D3] shadow-[0_4px_24px_rgba(23,20,15,0.06)] bg-white">
          {/* ---------- Left / image panel (hidden on mobile) ---------- */}
          <div className="relative hidden md:block">
            <img
              src={images.login}
              alt="DineValts"
              className="w-full h-full object-cover"
            />
            <div
              className="absolute inset-0"
              style={{
                background: `linear-gradient(180deg, rgba(23,20,15,0.05) 0%, rgba(23,20,15,0.15) 55%, rgba(23,20,15,0.75) 100%)`,
              }}
            />
            <div className="absolute top-4 left-4">
              <img
                src={images.Logo}
                alt="DineValts"
                className="w-[140px] rounded-lg object-cover"
              />
            </div>
            <div className="absolute bottom-8 left-8 right-8">
              <p className="font-serif text-2xl leading-snug text-[#F7F3E9]">
                Run your restaurant, all in one place.
              </p>
              <p className="mt-2 text-sm text-[#D9D2BE] max-w-sm">
                Sign in to manage your menu, orders and payouts.
              </p>
            </div>
          </div>

          {/* ---------- Right / form panel ---------- */}
          <div className="p-8 sm:p-12 flex flex-col justify-center">
            <div className="mb-8 md:hidden flex justify-center">
              <img
                src={images.Logo}
                alt="DineValts"
                className="w-[150px] rounded-lg object-cover"
              />
            </div>

            <span
              className="inline-block text-[11px] font-semibold tracking-[0.2em] uppercase mb-2"
              style={{ color: GOLD }}
            >
              Vendor Sign In
            </span>
            <h1 className="font-serif text-[1.65rem] text-[#17140F] mb-1">
              Welcome back
            </h1>
            <p className="text-sm text-[#6B6353] mb-7">
              Sign in to your DineValts vendor account.
            </p>

            <div className="mb-4">
              <label
                className="block text-xs font-semibold tracking-wide uppercase text-[#6B6353] mb-1.5"
                htmlFor="username"
              >
                Email address
              </label>
              <Input
                id="username"
                type="email"
                name="email"
                prefix={<IconMail className="w-4 h-4 text-[#B8AE93] mr-1" />}
                onKeyDown={handleKeyPress}
                required
                variant="borderless"
                className={`${fieldWrapperClass} py-2.5 px-3 text-sm text-[#231F18]`}
                onChange={(e) =>
                  setUserData({ ...userData, email: e.target.value })
                }
              />
            </div>

            <div className="mb-2">
              <label
                className="block text-xs font-semibold tracking-wide uppercase text-[#6B6353] mb-1.5"
                htmlFor="password"
              >
                Password
              </label>
              <Input.Password
                id="password"
                name="password"
                prefix={<IconLock className="w-4 h-4 text-[#B8AE93] mr-1" />}
                onKeyDown={handleKeyPress}
                required
                variant="borderless"
                className={`${fieldWrapperClass} py-2.5 px-3 text-sm text-[#231F18]`}
                onChange={(e) =>
                  setUserData({ ...userData, password: e.target.value })
                }
              />
            </div>

            <div className="flex justify-end mb-7">
              <span
                onClick={() => {
                  setForgotOpen(true);

                  setForgotData({
                    email: "",
                    otp: "",
                    password: "",
                    confirmPassword: "",
                    resetToken: ""
                  });

                  setStep(1);
                }}
                className="text-xs font-medium cursor-pointer hover:underline"
                style={{ color: GOLD }}
              >
                Forgot password?
              </span>
            </div>

            <Button
              loading={loading}
              type="button"
              onClick={handlelogin}
              className="!h-11 !rounded-lg !text-sm !font-semibold !text-[#17140F] !border-0 w-full"
              style={{ backgroundColor: GOLD }}
            >
              Sign in
            </Button>

            <p
              onClick={() => navigate("/register")}
              className="text-center mt-6 text-sm text-[#6B6353] cursor-pointer"
            >
              New to DineValts?{" "}
              <span className="font-semibold hover:underline" style={{ color: GOLD }}>
                Register your restaurant
              </span>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;